export default __webpack_public_path__ + "static/media/summary_planimages_116.193330eb.png";